import { render, staticRenderFns } from "./Prs.vue?vue&type=template&id=5834f762&"
import script from "./Prs.vue?vue&type=script&lang=js&"
export * from "./Prs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports